import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageProvider";
import { FxProvider } from "@/i18n/FxProvider";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Rooms from "@/pages/Rooms";
import Restaurant from "@/pages/Restaurant";
import Laundry from "@/pages/Laundry";
import Travel from "@/pages/Travel";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <FxProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/rooms" element={<Rooms />} />
                <Route path="/restaurant" element={<Restaurant />} />
                <Route path="/laundry" element={<Laundry />} />
                <Route path="/travel" element={<Travel />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </FxProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
